module.exports = __webpack_public_path__ + "img/pay-btn.60e39db.png";